import { LoadingOverlay } from "../../../components/Loading"
import { NotFound } from "../../../components/NotFound"
import { useFetchHistoricoAtendimentos } from "../../../services/atendimentos/useAtendimentos"
import { ReleasedVersion } from "../../../types/cliente/versoes/types"
import { HistoricoModal } from "./HistoricoModal"


export type HistoricoModalContainerProps = {
    releasedVersion: ReleasedVersion
    showModal: boolean
    onClose: () => void
}

export const HistoricoModalContainer = ({ releasedVersion, showModal, onClose }: HistoricoModalContainerProps) => {
    const { data, isFetching, error, isError, refetch } = useFetchHistoricoAtendimentos(
        releasedVersion.numFicha,
        releasedVersion.situacao,
        {
            enabled: !!releasedVersion.numFicha && !!releasedVersion.situacao,
            staleTime: Infinity,
        }
    );

    return (
        <>
            {isError && (
                <NotFound
                    error={error}
                    defaultMessage='Erro ao carregar a lista de histórico de atendimentos.'
                    retry={refetch}
                />
            )}
            {isFetching && <LoadingOverlay />}
            {data && <HistoricoModal
                showModal={showModal}
                onClose={onClose}
                historico={data}
                releasedVersion={releasedVersion}
            />}
        </>
    )
}